import type { BoxProps } from '@chakra-ui/react';
import { Box } from '@chakra-ui/react';

export function PageWrapper({ children, ...props }: BoxProps) {
  return (
    <Box as="main" {...props}>
      {children}
    </Box>
  );
}
